import { Component, OnDestroy } from '@angular/core';
import { RouteUtilService } from './shared/utils/route-util.service';
import { Router } from '@angular/router';
import { UserService } from './core/services/user.service';
import { AuthService } from './core/services/auth.service';
import { OktaPkceAuthService } from './core/services/okta-pkce-auth.service';
import { OktaRoutes, MasterRoutes , RouteNames} from './core/constants/route.constant';
import { TokenService } from './shared/utils/token.service';
import { TokenRefresherService } from './core/services/token-refresher.service';
import { UserIdleCheckerService } from './core/services/user-idle-checker.service';
import { LogoutBroadcastService } from './core/services/logout-broadcast.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy {
  capturedBarcodeText = "";
  keyControl = false;

  public authenticated: boolean = false;
  public userDetails: any;
  private subscription = {
    userProfile: null,
    authenticated: null,
    signOut: null
  };
  private readonly ngUnsubscribe = new Subject<void>();

constructor(private routeUtils: RouteUtilService,
  private authService: AuthService,
  private userService: UserService,
  public _service:TokenService,
  private oktapkceAuth: OktaPkceAuthService,
  private router:Router,
  private tokenRefresherService: TokenRefresherService,
  private userIdleCheckerService: UserIdleCheckerService,
  private logoutBroadcastService: LogoutBroadcastService){

}

  ngOnInit() {
    this.subscription.userProfile = this.userService.userProfileLoaded$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(response => {
      this.onUserProfileLoaded();
      this.initTimer();
    });  
    this.subscription.signOut = this.authService.signedOut$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(response => {
      this.onUserSignedOut(response);
      this.stopTimer();
      this.logoutBroadcastService.broadcastLogout();
    });

    this.init();
  }

  ngOnDestroy() {
	  if (this.subscription.userProfile)
    this.subscription.userProfile.unsubscribe();

    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private init() {
    // This will be checked when user is already logged in and refresh the page.
    this.authService.isAuthenticated().then(authResponse => {
      if (window.location.search.substring(1).startsWith('iss=')) {
        this.validateInternalAuthentication(authResponse);
        return;
      }

      if (authResponse.authenticated.all) {
        this.onUserProfileLoaded();
        return;
      } 
      
      if (window.location.pathname === '/' &&
        !this.oktapkceAuth.isAuthCallback()) {
        this.router.navigateByUrl(OktaRoutes.Login.Url, { replaceUrl: true });
        return;
      }

      this.initTimer();
    });
  }

  private initTimer(): void {
    this.tokenRefresherService.startTimer();
    this.userIdleCheckerService.startTimer();
  }

  private stopTimer(): void {
    this.tokenRefresherService.stopTimer();
    this.userIdleCheckerService.stopTimer();
  }

  private validateInternalAuthentication(authResponse) {
    !authResponse.authenticated.app
      ? this.routeUtils.navigate(MasterRoutes.Callback)
      : this.onUserProfileLoaded();
    }
  
    private onUserProfileLoaded() {
      const userDetails = this.userService.getDetails();
  
      if (userDetails) {
        this.authenticated = true;
      } else {
        this.oktapkceAuth.signOut();
      }
    }

  private onUserSignedOut(response: any) {
    if (!response.hasError) {
      this.authenticated = false;
      this.router.navigateByUrl(response.redirect.url, { replaceUrl: true })
    }
  }
 
}
